export default "uniform float id;\r\nvarying vec4 vWorldPos;\r\n\r\nvoid main() {\r\n    gl_FragColor = vec4(vWorldPos.xyz, id);\r\n}\n\n";